import { createFileRoute } from "@tanstack/react-router";
import FoodWellnessPantryPage from "@/pages/FoodWellnessPantryPage";
export const Route = createFileRoute("/food-and-wellness-pantry")({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title:
            "Food and Wellness Pantry | Neuro Wellness TMS Centers of America",
        },
        {
          name: "description",
          content:
            "Community Food and Wellness Pantry initiative at Neuro Wellness TMS Centers of America in Coral Springs, FL. Supporting physical nutrition alongside brain.",
        },
        {
          property: "og:title",
          content:
            "Food and Wellness Pantry | Neuro Wellness TMS Centers of America",
        },
        {
          property: "og:description",
          content:
            "Community Food and Wellness Pantry initiative at Neuro Wellness TMS Centers of America in Coral Springs, FL. Supporting physical nutrition alongside brain.",
        },
        {
          property: "og:url",
          content: "https://neurowellnesstms.com/food-and-wellness-pantry",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/food-and-wellness-pantry",
        },
      ],
    };
  },
});
function RouteComponent() {
  return <FoodWellnessPantryPage />;
}
